<app-breadcrumb [breadcrumb]="breadcrumb" />
<h2>{{ homeDetails.deviceName }}</h2>
<div class="card">
  <p class="title text-color">Dados cadastrados</p>
  <hr />

  <div class="data">
    <div>
      <p class="text-color subtitle">Nome</p>
      <p class="text-color">{{ homeDetails.deviceName }}</p>
    </div>
    <div>
      <p class="text-color subtitle">Unidade de pesquisa</p>
      <p class="text-color">{{ homeDetails.branch }}</p>
    </div>
  </div>
</div>

<div class="card">
  <p class="title text-color">Horário</p>
  <hr />

  <div class="data">
    <div>
      <p class="text-color subtitle">Última conexão em</p>
      <p class="text-color">
        @if (homeDetails.lastConnection) {
        {{ homeDetails.lastConnection | date : "dd/MM/yyyy HH:MM:SS" }}
        }@else {--}
      </p>
    </div>
    <div>
      <p class="text-color subtitle">Pesquisa atual</p>
      <p class="text-color">{{ homeDetails.currentPoll }}</p>
    </div>
  </div>

  <!-- <div class="data">
    <div>
      <p class="text-color subtitle">Bloquear tela</p>
      <p class="text-color">Sim</p>
    </div>
    <div>
      <p class="text-color subtitle">Mensagem de bloqueio</p>
      <p class="text-color">--</p>
    </div>
  </div> -->
</div>

<div class="card">
  <p class="title text-color">Localização</p>
  <hr />

  <div id="map" style="height: 300px; width: 100%"></div>
</div>

<div class="card">
  <p class="title text-color">Dispositivos da unidade</p>
  <hr />

  <app-table [tableHeader]="tableHeader" [list]="homeDetails.devicesData" />
</div>

<div class="card">
  <p class="title text-color">Horário dos turnos</p>
  <hr />

  <app-table
    [tableHeader]="shiftTableHeader"
    [list]="homeDetails.availableShifts"
  />
</div>

<div class="card">
  <p class="title text-color">Lista de e-mails</p>
  <hr />

  <app-table [tableHeader]="emailsTableHeader" [list]="homeDetails.emailList" />
</div>
